<template>
    <!-- 等权重 -->
    <div class="adjustBox">
        <div class="search">
            <el-select v-model="searchType" class="select-one search-input" style="width: 150px;" placeholder="请选择类型">
                <el-option label="私募产品" value="私募产品"></el-option>
                <el-option label="比较基准" value="比较基准"></el-option>
                <el-option label="展恒指数" value="展恒指数"></el-option>
            </el-select>
            <el-input placeholder="请输入内容" class="search-input ml20" prefix-icon="el-icon-search" v-model="search"></el-input>
            <el-button type="normal" class="ml20" @click="serach">搜索</el-button>
        </div>
        <div class="mt30">
            <el-table class="table-two" :data="gridData" height="240" border>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column property="secuNameAbbr" label="产品名称" width="230">
                    <template slot-scope="scope">
                        <a v-if="searchType=='私募产品'" class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                        <span v-else :title="scope.row.secuNameAbbr">{{scope.row.secuNameAbbr}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="managerName" label="基金管理人"></el-table-column>
                <el-table-column property="createDate" label="成立日期"></el-table-column>
                <el-table-column property="newestDate" label="最新净值日期"></el-table-column>
                <el-table-column property="newestEquity" label="最新净值">
                    <template slot-scope="scope"><span>{{scope.row.newestEquity?parseFloat(scope.row.newestEquity).toFixed(4):'--'}}</span></template>
                </el-table-column>
                <el-table-column property="thisYearYield" label="今年以来收益">
                    <template slot-scope="scope">
                        <span v-if="scope.row.thisYearYield" :class="[{rColor:scope.row.thisYearYield>0},{gColor:scope.row.thisYearYield<0}]">{{parseFloat(scope.row.thisYearYield*100).toFixed(2)}}%</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column property="opera" label="操作" width="150">
                    <template slot-scope="scope">
                        <span class="mainColor" @click="addTrade(scope.row)">添加到交易标的</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="adjustBox-Subject form-one">
                <el-row class="row-two clearfix">
                    <h3 class="title">交易标的</h3>
                    <el-button class="fr" @click="submit">确认</el-button>
                </el-row>
                <el-table class="table-two mt20" :data="varianceData" border  height="381">
                    <el-table-column type="index" width="100"></el-table-column>
                    <el-table-column property="secuNameAbbr" label="产品名称">
                        <template slot-scope="scope">
                            <a v-if="searchType=='私募产品'" class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/product?code='+scope.row.innerCode" target="_blank">{{scope.row.secuNameAbbr}}</a>
                            <span v-else :title="scope.row.secuNameAbbr">{{scope.row.secuNameAbbr}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="date" label="当期权重">
                        <template slot-scope="scope">
                            <span>{{scope.row.dqCon}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="opera" label="操作" width="200">
                        <template slot-scope="scope">
                            <span class="mainColor" @click="deleteTrade(scope.row)">删除</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "riskEvaluation",
    data() {
        return {
            // 基金搜索
            search:'',
            gridData: [],
            varianceData:[],
            searchType: '私募产品',
            regionList: []
        }
    },
    mounted() {
        
    },
    methods: {
        // 基金搜索
        getFundLists() {
            let vm = this
            vm.gridData = []
            vm.$http.post(vm.$apiPath.GetFundSeachResult, {
                KeyWords: vm.search.trim(), //模糊查询关键词
                Page: 1, //页码
                PageNum: 10 //每页条数
            }).then(res => {
                // console.log(res);
                if (res.data.code == "200") {
                    vm.gridData = res.data.data.dataList
                }
            }).catch(err => { })
        },
        getBaselineLists() {
            let vm = this
            vm.$http.post(vm.$apiPath.GetCompareFuzzySeachResult, {
                innerType: vm.searchType, //内部类型
                KeyWords: vm.search.trim() //模糊查询关键词
            }).then(res => {
                // console.log(res);
                if (res.data.code == 200) {
                    let search = res.data.data.dataList;
                    search.forEach(item => {
                        item.managerName = '--'
                        item.createDate = '--'
                        item.newestDate = '--'
                        item.secuNameAbbr = item.secuName
                    })
                    vm.gridData = search
                }
            })
        },
        addTrade(val) {
            this.varianceData.push({
                innerCode:val.innerCode,
                secuNameAbbr:val.secuNameAbbr,
                dqCon:'--',
                values: []
            })
            this.$message.success('添加成功')
        },
        // 等权重
        submit() {
            this.varianceData.forEach((item,i) => {
                item.dqCon = parseFloat(100 / this.varianceData.length).toFixed(2)
            })
        },
        // 删除交易标的
        deleteTrade(val) {  
            const i1 = this.varianceData.findIndex(item => item.innerCode == val.innerCode)
            this.varianceData.splice(i1, 1)
        },
        serach() {
            if(this.search != '') {
                if(this.searchType == '私募产品') {
                    this.getFundLists()
                } else {
                    this.getBaselineLists()
                }
            }
        },
    },
}
</script>

<style scoped lang="less">
.adjustBox {
    .search {
        display: flex;justify-content: center;align-items: center;
        &-input {
            width: 410px;
            /deep/.el-input__inner{height: 30px;line-height: 30px;border-color: @borderColor;}
            /deep/.el-input__icon{line-height: 30px;}
        }
    }
    .mainColor {cursor: pointer;}
    &-Subject {
        padding: 30px 15px 0;
    }
}
</style>